
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.product-grid')) return;
    var formatWithCurrency = document.body.dataset.moneyFormat;

    const sessionProductHandle = sessionStorage.getItem('highlightProduct');
    const urlParams = new URLSearchParams(window.location.search);
    const utmProductHandle = urlParams.get('utm_product_handle');
    
    const productHandle = utmProductHandle || sessionProductHandle;
    if (!productHandle) return;

    sessionStorage.removeItem('highlightProduct');
    sessionStorage.removeItem('highlightProductFrom');

    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    const productLinks = productGrid.querySelectorAll('a[href*="/products/"]');
    let productListItem = null;

    productLinks.forEach((link) => {
      if (link.getAttribute('href').includes(productHandle)) {
        productListItem = link.closest('.grid__item');
      }
    });

    if (productListItem && productGrid.firstChild) {
      productGrid.insertBefore(productListItem, productGrid.firstChild);
      productListItem.classList.add('highlight');
      return;
    }

    const regex = /BF(\d+)FB/;
    const utmValue = getCookieByProduct('utm_discount');
    const utm = urlParams.get('utm_discount');
    const discount = utm?.match(regex)?.[1] || utmValue?.match(regex)?.[1]; 

    function applyDisplayDiscount(cents,discountPercent = 0) {
      const discounted = Math.ceil(cents * (1 - discountPercent / 100));
      return discounted;
    }


    var loadingOverlay = document.querySelector('.loading-overlay.gradient');
    if (loadingOverlay) loadingOverlay.classList.add('loading');
    fetch(`/products/${productHandle}.js`)
      .then((res) => res.json())
      .then((product) => {
        let priceSale = null
        if(discount){
          const raw = product.price;
          const cents = raw ? parseInt(raw, 10) : null;
          if (cents){
            const discounted = applyDisplayDiscount(cents,discount);
            priceSale = `<div class="price-discount">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M6.66667 13.3333C6.4 13.3333 6.14444 13.2833 5.9 13.1833C5.65556 13.0833 5.43889 12.9389 5.25 12.75C4.92778 12.4278 4.65 12.2167 4.41667 12.1167C4.18333 12.0167 3.83333 11.9667 3.36667 11.9667C2.81111 11.9667 2.33889 11.7722 1.95 11.3833C1.56111 10.9944 1.36667 10.5222 1.36667 9.96667C1.36667 9.5 1.31667 9.15 1.21667 8.91667C1.11667 8.68333 0.905555 8.40555 0.583333 8.08333C0.394444 7.89444 0.25 7.67778 0.15 7.43333C0.05 7.18889 0 6.93333 0 6.66667C0 6.4 0.05 6.14444 0.15 5.9C0.25 5.65556 0.394444 5.43889 0.583333 5.25C0.905555 4.92778 1.11667 4.65 1.21667 4.41667C1.31667 4.18333 1.36667 3.83333 1.36667 3.36667C1.36667 2.81111 1.56111 2.33889 1.95 1.95C2.33889 1.56111 2.81111 1.36667 3.36667 1.36667C3.83333 1.36667 4.18333 1.31667 4.41667 1.21667C4.65 1.11667 4.92778 0.905555 5.25 0.583333C5.43889 0.394444 5.65556 0.25 5.9 0.15C6.14444 0.05 6.4 0 6.66667 0C6.93333 0 7.18889 0.05 7.43333 0.15C7.67778 0.25 7.89444 0.394444 8.08333 0.583333C8.40555 0.905555 8.68333 1.11667 8.91667 1.21667C9.15 1.31667 9.5 1.36667 9.96667 1.36667C10.5222 1.36667 10.9944 1.56111 11.3833 1.95C11.7722 2.33889 11.9667 2.81111 11.9667 3.36667C11.9667 3.83333 12.0167 4.18333 12.1167 4.41667C12.2167 4.65 12.4278 4.92778 12.75 5.25C12.9389 5.43889 13.0833 5.65556 13.1833 5.9C13.2833 6.14444 13.3333 6.4 13.3333 6.66667C13.3333 6.93333 13.2833 7.18889 13.1833 7.43333C13.0833 7.67778 12.9389 7.89444 12.75 8.08333C12.4278 8.40555 12.2167 8.68333 12.1167 8.91667C12.0167 9.15 11.9667 9.5 11.9667 9.96667C11.9667 10.5222 11.7722 10.9944 11.3833 11.3833C10.9944 11.7722 10.5222 11.9667 9.96667 11.9667C9.5 11.9667 9.15 12.0167 8.91667 12.1167C8.68333 12.2167 8.40555 12.4278 8.08333 12.75C7.89444 12.9389 7.67778 13.0833 7.43333 13.1833C7.18889 13.2833 6.93333 13.3333 6.66667 13.3333ZM6.66667 12C6.75556 12 6.84167 11.9806 6.925 11.9417C7.00833 11.9028 7.07778 11.8556 7.13333 11.8C7.58889 11.3444 8.01667 11.0361 8.41667 10.875C8.81667 10.7139 9.33333 10.6333 9.96667 10.6333C10.1556 10.6333 10.3139 10.5694 10.4417 10.4417C10.5694 10.3139 10.6333 10.1556 10.6333 9.96667C10.6333 9.32222 10.7139 8.80278 10.875 8.40833C11.0361 8.01389 11.3444 7.58889 11.8 7.13333C11.9333 7 12 6.84444 12 6.66667C12 6.48889 11.9333 6.33333 11.8 6.2C11.3444 5.74444 11.0361 5.31667 10.875 4.91667C10.7139 4.51667 10.6333 4 10.6333 3.36667C10.6333 3.17778 10.5694 3.01944 10.4417 2.89167C10.3139 2.76389 10.1556 2.7 9.96667 2.7C9.32222 2.7 8.80278 2.61944 8.40833 2.45833C8.01389 2.29722 7.58889 1.98889 7.13333 1.53333C7.07778 1.47778 7.00833 1.43056 6.925 1.39167C6.84167 1.35278 6.75556 1.33333 6.66667 1.33333C6.57778 1.33333 6.49167 1.35278 6.40833 1.39167C6.325 1.43056 6.25556 1.47778 6.2 1.53333C5.74444 1.98889 5.31667 2.29722 4.91667 2.45833C4.51667 2.61944 4 2.7 3.36667 2.7C3.17778 2.7 3.01944 2.76389 2.89167 2.89167C2.76389 3.01944 2.7 3.17778 2.7 3.36667C2.7 4.01111 2.61944 4.53056 2.45833 4.925C2.29722 5.31944 1.98889 5.74444 1.53333 6.2C1.4 6.33333 1.33333 6.48889 1.33333 6.66667C1.33333 6.84444 1.4 7 1.53333 7.13333C1.98889 7.58889 2.29722 8.01667 2.45833 8.41667C2.61944 8.81667 2.7 9.33333 2.7 9.96667C2.7 10.1556 2.76389 10.3139 2.89167 10.4417C3.01944 10.5694 3.17778 10.6333 3.36667 10.6333C4.01111 10.6333 4.53056 10.7139 4.925 10.875C5.31944 11.0361 5.74444 11.3444 6.2 11.8C6.25556 11.8556 6.325 11.9028 6.40833 11.9417C6.49167 11.9806 6.57778 12 6.66667 12ZM8.33333 9.33333C8.61111 9.33333 8.84722 9.23611 9.04167 9.04167C9.23611 8.84722 9.33333 8.61111 9.33333 8.33333C9.33333 8.05556 9.23611 7.81944 9.04167 7.625C8.84722 7.43055 8.61111 7.33333 8.33333 7.33333C8.05556 7.33333 7.81944 7.43055 7.625 7.625C7.43055 7.81944 7.33333 8.05556 7.33333 8.33333C7.33333 8.61111 7.43055 8.84722 7.625 9.04167C7.81944 9.23611 8.05556 9.33333 8.33333 9.33333ZM4.5 8.83333C4.63333 8.96667 4.78889 9.03333 4.96667 9.03333C5.14444 9.03333 5.3 8.96667 5.43333 8.83333L8.83333 5.45C8.96667 5.31667 9.03333 5.15833 9.03333 4.975C9.03333 4.79167 8.96667 4.63333 8.83333 4.5C8.7 4.36667 8.54167 4.3 8.35833 4.3C8.175 4.3 8.01667 4.36667 7.88333 4.5L4.5 7.9C4.36667 8.03333 4.3 8.18889 4.3 8.36667C4.3 8.54444 4.36667 8.7 4.5 8.83333ZM5 6C5.27778 6 5.51389 5.90278 5.70833 5.70833C5.90278 5.51389 6 5.27778 6 5C6 4.72222 5.90278 4.48611 5.70833 4.29167C5.51389 4.09722 5.27778 4 5 4C4.72222 4 4.48611 4.09722 4.29167 4.29167C4.09722 4.48611 4 4.72222 4 5C4 5.27778 4.09722 5.51389 4.29167 5.70833C4.48611 5.90278 4.72222 6 5 6Z" fill="#D02928"></path>
                    </svg>
                    ${Shopify.formatMoney(discounted, formatWithCurrency)}
                  <span>(After discount)</span></div>`;
          }
        }
        
        const productHTML = `
          <li class="grid__item scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: 0;">
  <div class="card-wrapper product-card-wrapper underline-links-hover">
    <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
      <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
        <div class="card__media">
          <div class="media media--transparent media--hover-effect">
            <img srcset="${product.images[0]}" src="${product.images[0]}" alt="alt=" ${product.title}""
              class="motion-reduce" width="2000" height="2000">
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <h3 class="card__heading">
              <a href="/products/${product.handle}" class="full-unstyled-link">
                ${product.title}
              </a>
            </h3>
          </div>

          <div class="card__badge bottom left">
          </div>
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <h3 class="card__heading h5">
                <a href="/products/${product.handle}" class="full-unstyled-link">${product.title}</a>
          </h3>
          <div class="card-information"><span class="caption-large light"></span>
            <div class="
    price  price--on-sale">
              <div class="price__container">
                <div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular money">${Shopify.formatMoney(product.price, "${{amount}}")}
                  </span>
                </div>
                <div class="price__sale">

                  <div class="box-price-final">
                    <span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item price-item--sale price-item--last money">
                      ${Shopify.formatMoney(product.price, formatWithCurrency)}
                    </span>

                  </div>
                  <small class="unit-price caption hidden">
                    <span class="visually-hidden">Unit price</span>
                    <span class="price-item price-item--last">
                      <span></span>
                      <span aria-hidden="true">/</span>
                      <span class="visually-hidden">&nbsp;per&nbsp;</span>
                      <span>
                      </span>
                    </span>
                  </small>
                </div>
                ${discount && priceSale ? priceSale : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</li>
        `;
        productGrid.insertAdjacentHTML('afterbegin', productHTML);
        var lastItem = productGrid.querySelector('.grid__item:last-child');
        if (lastItem) lastItem.remove();
        if (loadingOverlay) loadingOverlay.classList.remove('loading');
        console.log('✅ Product inserted at top of collection');
      })
      .catch((err) => {
        console.error('❌ Error fetching product:', err);
        if (loadingOverlay) loadingOverlay.classList.remove('loading');
      });
  });
